var map = {
	"./all.svg": "./images/flags/all.svg",
	"./at.svg": "./images/flags/at.svg",
	"./be.svg": "./images/flags/be.svg",
	"./bg.svg": "./images/flags/bg.svg",
	"./by.svg": "./images/flags/by.svg",
	"./ca.svg": "./images/flags/ca.svg",
	"./ch.svg": "./images/flags/ch.svg",
	"./cz.svg": "./images/flags/cz.svg",
	"./de.svg": "./images/flags/de.svg",
	"./dk.svg": "./images/flags/dk.svg",
	"./ee.svg": "./images/flags/ee.svg",
	"./es.svg": "./images/flags/es.svg",
	"./fi.svg": "./images/flags/fi.svg",
	"./fr.svg": "./images/flags/fr.svg",
	"./gb.svg": "./images/flags/gb.svg",
	"./gr.svg": "./images/flags/gr.svg",
	"./hr.svg": "./images/flags/hr.svg",
	"./hu.svg": "./images/flags/hu.svg",
	"./ie.svg": "./images/flags/ie.svg",
	"./it.svg": "./images/flags/it.svg",
	"./lt.svg": "./images/flags/lt.svg",
	"./lu.svg": "./images/flags/lu.svg",
	"./lv.svg": "./images/flags/lv.svg",
	"./mk.svg": "./images/flags/mk.svg",
	"./nl.svg": "./images/flags/nl.svg",
	"./no.svg": "./images/flags/no.svg",
	"./pl.svg": "./images/flags/pl.svg",
	"./pt.svg": "./images/flags/pt.svg",
	"./ro.svg": "./images/flags/ro.svg",
	"./ru.svg": "./images/flags/ru.svg",
	"./se.svg": "./images/flags/se.svg",
	"./si.svg": "./images/flags/si.svg",
	"./sk.svg": "./images/flags/sk.svg",
	"./tr.svg": "./images/flags/tr.svg",
	"./ua.svg": "./images/flags/ua.svg",
	"./uk.svg": "./images/flags/uk.svg",
	"./us.svg": "./images/flags/us.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./images/flags sync recursive ^\\.\\/.*\\.svg$";